import { alpha, darken, Theme } from '@material-ui/core'
import { Overrides } from '@material-ui/core/styles/overrides'

const Button = (theme: Theme): Overrides => {
  return {
    MuiButtonBase: {
      root: {
        textTransform: 'capitalize',
        fontSize: '1rem',
        padding: '8px',
        borderRadius: '4px',
        '&:hover': {
          backgroundColor: alpha(theme.palette.primary.main, 0.1),
        },
      },
    },
    MuiButton: {
      root: {
        textTransform: 'capitalize',
      },
      contained: {
        backgroundColor: theme.palette.primary.main,
        boxShadow: 'none',
        '&:hover': {
          backgroundColor: darken(theme.palette.primary.main, 0.1),
          boxShadow: theme.shadows[1],
        },
        '& span': {
          color: '#ffffff',
        },
        '&:disabled': {
          backgroundColor: 'rgba(0, 0, 0, 20%)',
        },
      },
    },
  }
}

export default Button
